module.exports = {$schema:'../../../../../platform/@jutro/legacy/uimetadata/common/json-schema/metadata.schema.json',jutro:'10.14.0'}